// tslint:disable: max-classes-per-file
import { Directive, TemplateRef } from '@angular/core';

/**
 * Header side (right) actions for the segment composer
 */
@Directive({
    selector: '[emma-textarea-header-tpl]',
    standalone: false
})
export class EMMATextAreaHeaderDirective {
  constructor(public template: TemplateRef<unknown>) {}
}
/**
 * Header actions for the segment composer
 */
@Directive({
    selector: '[emma-textarea-footer-tpl]',
    standalone: false
})
export class EMMATextAreaFooterDirective {
  constructor(public template: TemplateRef<unknown>) {}
}
/**
 * Footer side (right) actions for the segment composer
 */
@Directive({
    selector: '[emma-textarea-highlight-tpl]',
    standalone: false
})
export class EMMATextAreaHighlightDirective {
  constructor(public template: TemplateRef<unknown>) {}
}
